
<row>
  <column>
    <component
      :is="validationModel && validationFieldName ? 'config-field-validation' : 'div'"
      :model="validationModel"
      :field-name="validationFieldName"
    >
      <p>If <span v-html="htmlString"></span></p>
    </component>
  </column>
  <suffix>
    <div class="dropdown" v-if="!hideControls">
      <button :disabled="disabled" class="dropdown-toggle btn-icon clear-area controllers" id="conditionButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <icon class="kebab"></icon>
        <span class="sr-only">More Actions Dropdown</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="conditionButton">
        <li v-if="canMoveUp">
          <button :disabled="disabled" @click="$emit('move-up', conditionalRuleSet)" class="dropdown-item">Move Up</button>
        </li>
        <li v-if="canMoveDown">
          <button :disabled="disabled" @click="$emit('move-down', conditionalRuleSet)" class="dropdown-item">Move Down</button>
        </li>
        <li>
          <button :disabled="disabled" @click="edit" class="dropdown-item">Edit</button>
        </li>
        <li>
          <button :disabled="disabled" @click="remove" class="dropdown-item">Delete</button>
        </li>
      </ul>
    </div>
  </suffix>
</row>
